export default __webpack_public_path__ + "static/media/solucao-01.575a9a03.webp";